import { render, staticRenderFns } from "./AddFolder.vue?vue&type=template&id=13c639ff"
import script from "./AddFolder.vue?vue&type=script&lang=js"
export * from "./AddFolder.vue?vue&type=script&lang=js"
import style0 from "../../operations.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports